export default __webpack_public_path__ + "static/media/no-order.9b5cfbbf.png";